{
	"name": "plant",
	"size": [32, 32],
	"kit": "arcade",
	"parts": [
		{ "shape": "pipe", "from": [15, 12], "to": [15, 22], "width": 2, "role": "stem", "litRole": "leaf_lit" },
		{ "shape": "disc", "inset": [4, 6, 17, 18], "role": "leaf", "litRole": "leaf_lit", "borderRole": "leaf_dark" },
		{ "shape": "disc", "inset": [17, 4, 5, 19], "role": "leaf", "litRole": "leaf_lit", "borderRole": "leaf_dark" },
		{ "shape": "disc", "inset": [10, 2, 10, 21], "role": "leaf_lit", "borderRole": "leaf_dark" },
		{ "shape": "disc", "inset": [8, 10, 13, 14], "role": "leaf_dark" },
		{ "shape": "taper", "inset": [8, 21, 8, 2], "role": "clay", "litRole": "clay_lit", "shadeRole": "clay_dark", "narrow": 0.35, "towards": "bottom" },
		{ "shape": "panel", "inset": [7, 20, 7, 9], "role": "clay_lit" },
		{ "shape": "panel", "inset": [9, 22, 9, 8], "role": "soil_dark" }
	]
}
